import { MessagePathRecord, TopicRecord } from "@/shared/domain/topics";

import { KeywordFilter } from "./filter";

export interface FilterResult {
  type: "topic" | "messagePath";
  match?: Match;
}

export interface MessagePathFilterResult extends FilterResult {
  type: "messagePath";
  messagePath: MessagePathRecord;
}

export interface TopicFilterResult extends FilterResult {
  type: "topic";
  topic: TopicRecord;
}

interface Match {
  /** The filter that produced this match */
  filter: KeywordFilter;

  /** The start and end index of the match within the path part */
  position: [number, number];
}

export function isMessagePathFilterResult(
  result: FilterResult,
): result is MessagePathFilterResult {
  return result.type === "messagePath";
}

export function isTopicFilterResult(
  result: FilterResult,
): result is TopicFilterResult {
  return result.type === "topic";
}
